module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "contents"
    }
  }, [_c('h2', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('table', {
    staticClass: "calibre10",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre11"
  }, [_c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#ch01"
    }
  }, [_vm._v("The Hackleton Case")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#ch02"
    }
  }, [_vm._v("The Affair in the Maze")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#ch03"
    }
  }, [_vm._v("The Immediate Results")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chief Constable")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evidence in the Case")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Toxicologist")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pot of Curare")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opportunity, Method, and Motive")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burglary at Whistlefield")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Attack in the Maze")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Squire’s Theories")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Attack")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dart")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Forged Cheque")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secretary’s Affairs")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Attack in the Maze")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Siege of the Maze")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "n"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Truth of the Matter")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0